export enum AssessmentType {
  Avaliacao = 0,
  Simulado = 1,
  ListaExercicios = 2,
  Quiz = 3,
  Redacao = 4,
}
